import { atom } from 'jotai';
export enum SettingsPage {
    ProfilePreferences = 'ProfilePreferences',
    SchedulingPreferences = 'SchedulingPreferences',
}

export const userModalStateAtom = atom<boolean>(false);
export const currentSettingViewAtom = atom<string>(SettingsPage.ProfilePreferences);
